/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { combineReducers } from 'redux';

import app from './app';
import auth from './auth';
import bootstrap from './bootstrap';
import staticPage from './staticPage';
import signup from './signup';
import login from './login';
import user from './user';
import profile from './profile';
import company from './company';
import job from './job';
import jobs from './jobs';
import shortlist from './shortlist';
import talents from './talents';
import messages from './messages';
import message from './message';
import paymentMethod from './paymentMethod';
import moodboard from './moodboard';
import blog from './blog';
import blogPost from './blogPost';
import blogCategories from './blogCategories';
import errorMessage from './errorMessage';
import successMessage from './successMessage';

import requestCodeForm from './requestCodeForm';
import verifyCodeForm from './verifyCodeForm';
import profileForm from './profileForm';
import companyForm from './companyForm';
import jobForm from './jobForm';
import saveTalentForm from './saveTalentForm';
import inviteForm from './inviteForm';
import searchJobsForm from './searchJobsForm';
import jobOfferForm from './jobOfferForm';
import selectPaymentMethodForm from './selectPaymentMethodForm';
import freelanceForm from './freelanceForm';
import passwordAuthenticateForm from './passwordAuthenticateForm';
import resetPasswordForm from './resetPasswordForm';
import updatePasswordForm from './updatePasswordForm';
import positionForm from './positionForm';
import requestTalentForm from './requestTalentForm';
import quickRequestTalentForm from './quickRequestTalentForm';

const rootReducer = combineReducers({
  app,
  auth,
  bootstrap,
  staticPage,
  signup,
  login,
  user,
  profile,
  company,
  job,
  jobs,
  shortlist,
  talents,
  messages,
  message,
  paymentMethod,
  moodboard,
  blog,
  blogPost,
  blogCategories,
  errorMessage,
  successMessage,

  requestCodeForm,
  verifyCodeForm,
  profileForm,
  companyForm,
  jobForm,
  saveTalentForm,
  inviteForm,
  searchJobsForm,
  jobOfferForm,
  selectPaymentMethodForm,
  freelanceForm,
  passwordAuthenticateForm,
  resetPasswordForm,
  updatePasswordForm,
  positionForm,
  requestTalentForm,
  quickRequestTalentForm,
});

export default rootReducer;
